import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from "firebase/app"
import "firebase/auth"
import "firebase/firestore"
import axios from "axios"

import firebaseConfig from '../../config/firebase'

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

Vue.use(firebase)

const db = firebase.firestore()

Vue.use(Vuex)

const sendSlackMessage = async (text = "testing") => {
  await axios.post(
    "https://hooks.slack.com/services/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",
    { text }
  );
}

export const store = new Vuex.Store({

  state: {
      activeForm: true
    },
    getters: {
      activeForm: state => state.activeForm

    },
    mutations: {
      formState(state) {
        state.activeForm = false
      }
    },
    actions: {
      SEND_FORM(context, payload) {
        try {

          sendSlackMessage()
          context;
          const createdAt = new Date()
          db.collection("messages").add({
            to: ['jakejonesinfo@gmail.com', 'critchfieldsprayfoam@yahoo.com'],
            from: payload.email,
            name: payload.name,
            email: payload.email,
            message: {
              subject: payload.name,
              text: payload.message
            },
            createdAt: createdAt
          })
          .then((docRef) => {
            return {
              addId: db.collection('messages').doc(docRef.id).update({
                id: docRef.id
              }),
              changeState: context.commit('formState')
            }
          })
        } catch (error) {
          sendSlackMessage(error);
        }
      }
    }
});



